<panel>
	<h1>{{'sale.open-calls' | translate}}</h1>
	<list-view [emptyLabel]="'sale.open-calls.open-calls-list-empty-label'">
		<header>{{ 'opencalls.column.companyname' | translate }}</header>
		<header>{{ 'opencalls.column.zipcode' | translate }}</header>
		<header>{{ 'opencalls.column.business' | translate }}</header>
		<header defaultSort="ascending">{{ 'opencalls.column.planneddate' | translate }}</header>
		<header>{{ 'opencalls.column.lateststatus' | translate }}</header>
		<row *listData="let call from opencalls" (action)="displayTaskflow(call.taskflow)">
			<column>{{ call.taskflow!.company!.name }}</column>
			<column>{{ call.taskflow!.company!.zipcode }}</column>
			<column>{{ call.taskflow!.company!.companyBusinesses.length > 0 ? call.taskflow!.company!.companyBusinesses[0].business!.name : ('general.na' | translate) }}</column>
			<column>{{ call.dateOnly ? (call.plannedDate | customDate: 'shortDate') : call.plannedDate }}</column>
			<column>{{ getLatestStatus(call) | translate }}</column>
		</row>
	</list-view>
</panel>
